module.exports = __webpack_public_path__ + "static/media/handbags_4_getty_desktop.56db53fb.jpg";